import {
  initialState,
  Actions,
  State,
  NEW_REACTION,
  NEW_REACTION_SUCCESS,
  NEW_REACTION_ERROR,
  RESET_NEW_REACTION,
} from "../../types/reaction/new-reaction";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_REACTION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_REACTION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_REACTION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_REACTION:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
